<template>
    <div>
         <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
         <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
         <div class="autochartistWeb whiteBG p-3" v-if="!pageLoader && url != ''">
              <iframe :src = "url"  width="100%" height="100%" class="img"></iframe>
         </div>
    </div>
</template>
<script> 
    import moment from 'moment'
	export default {
		name: 'Auto-Chartist',
		data() {
			return {
				pageName : this.$options.name,
				url : '',
                pageLoader : false,
                msg_type : '',
                response_msg : '',
			}
		},
		methods:{
            listing(){
                let inputJson = {
                    'globalParams' : {
                        'email' : this.get_user.email
                    },
                    'localParams' : {'parameter' : this}
                }
                this._runGetAutoChartistWebUrl(inputJson)
            }
		},
		created(){
            this.listing()
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/fxView/tools/pages/auto_chartist_web.vue